<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { navigate } from 'svelte-navigator';

  import questions from './questions.json';
  import { onMount } from 'svelte';
  import { handleFetchRetry } from '../../handleFetchRetry';
  import { debugLog } from '../../../lib/debug-log';

  interface response {
    [key: string]: string | null;
  }

  let responses: response = {};
  let purchasePaybackId: string;
  let allQuestionsAnswered = false;

  // read from localstorage
  if (localStorage.getItem('purchasePayBack') !== null) {
    purchasePaybackId = JSON.parse(
      localStorage.getItem('purchasePayBack') as string,
    ).id;
  }

  const checkAllQuestionsAnswered = () => {
    const answeredCount = Object.values(responses).filter(
      (response) => response !== null,
    ).length;
    allQuestionsAnswered = answeredCount === questions.length;
  };

  const saveQuestions = async () => {
    // read and update customer process status
    const item = localStorage.getItem('customerProcess');
    const customerProcess = item !== null ? JSON.parse(item as string) : null;

    // Save questions responses locally
    localStorage.setItem('questionsResponses', JSON.stringify(responses));

    localStorage.setItem(
      'customerProcess',
      JSON.stringify({
        ...customerProcess,
        questions: true,
      }),
    );

    debugLog('Questions responses saved locally:', responses);

    /* Comment out backend call for now    */
    let URL = `${process.env.SVELTE_APP_FE_REMOTE_URL}/api/mbvan`;

    await handleFetchRetry(() =>
      fetch(`${URL}/purchasepaybacks/${purchasePaybackId}`, {
        method: 'PATCH',
        headers: {
          Accept: 'application/json, text/plain',
          'Content-Type': 'application/json;charset=UTF-8',
          'X-Custom-Header': 'mb-cashback-2025-header',
        },
        body: JSON.stringify({
          questions: JSON.stringify(responses),
        }),
      }),
    );

    // Navigate to step 5 (Terms & Conditions)
    navigate('/step/5');
  };

  onMount(() => {
    questions.map((q) => {
      responses[q.question] = null;
    });
  });
</script>

<div class="space-y-8">
  <div class="space-y-6 overflow-auto">
    <h1 class="font-CorpoA text-3xl text-black">{$_('Our questions to you')}</h1>

    <p class="text-justify leading-relaxed text-cubiq-grey-font">
      {$_(
        'With our cashback campaign, we would like to thank you for your loyalty and your thank trust. We would also like to develop this campaign further and so we would be very happy if you take the time and for answer the following questions for us. Our special thanks for this as well',
      )}
    </p>

    <div class="space-y-6">
      {#each questions as question, index}
        <div class="space-y-3">
          <h3
            class="font-sans font-medium leading-relaxed text-cubiq-grey-font"
          >
            <span class="text-cubiq-grey-font-light">{index + 1}.</span>
            {question.question}
            <span class="ml-1 text-cubiq-dark-blue">*</span>
          </h3>
          <div class="space-y-2 pl-6">
            {#each question.options as option}
              <label class="group flex cursor-pointer items-start gap-3">
                <input
                  type="radio"
                  name={question.question}
                  value={option}
                  class="relative mt-1 h-4 w-4 flex-shrink-0 cursor-pointer appearance-none rounded-full border-2 border-cubiq-grey-400 bg-transparent text-cubiq-dark-blue transition-all duration-200 checked:border-cubiq-dark-blue checked:bg-cubiq-dark-blue focus:border-cubiq-dark-blue focus:ring-2 focus:ring-cubiq-dark-blue-200"
                  on:change={(e) => {
                    // @ts-ignore
                    responses[question.question] = e.target.value;
                    checkAllQuestionsAnswered();
                  }}
                />
                <span
                  class="leading-relaxed text-cubiq-grey-font transition-colors duration-200 group-hover:text-cubiq-dark-blue"
                  >{option}</span
                >
              </label>
            {/each}
          </div>
        </div>
      {/each}
    </div>
  </div>

  <div class="flex justify-end py-6">
    <div class="flex w-full justify-between">
      <p class="text-cubiq-dark-blue">
        * {$_('required')}
      </p>
      <button
        class={allQuestionsAnswered ? 'button' : 'button-disabled'}
        type="submit"
        disabled={!allQuestionsAnswered}
        data-umami-event="next button on questions page clicked"
        data-umami-event-page="/step/4"
        on:click|preventDefault={async () => {
          await saveQuestions();
        }}>{$_('Next')}</button
      >
    </div>
  </div>
</div>
